
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getCategories() {
        const url = `${API_URL}/categories`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/categories`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/categories/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/categories/${id}`, { headers: authHeader() });
    },
};